export const skipDataField = {
  props: {
    skipDataFieldTab: {
      type: Object,
      default: () => {
        return {
          budget_item_code: 'budget_sub_item_code',
          budget_kind_item_code: 'budget_sub_kind_item_code'
        };
      }
    }
  }
};
